export default __webpack_public_path__ + "static/media/design-school.e52855f0.webp";